import type { BookingTypeLabel } from '../types';

/**
 * Painel horizontal compacto na pagina de detalhe — explica em uma linha
 * como funciona o tipo de reserva.
 *
 * Layout: icone colorido a esquerda (verde p/ Imediata, ambar p/ Sob
 * Consulta), titulo + paragrafo unico a direita. Sem listas/timelines —
 * texto direto pra nao gastar espaco e nao competir com o resto da pagina.
 */
export function BookingTypePanel({ type }: { type: BookingTypeLabel }) {
  const isInstant = type === 'Confirmação Imediata';

  return (
    <section
      className={`booking-type-panel booking-type-panel--${isInstant ? 'instant' : 'request'}`}
      aria-label={`Como funciona: ${type}`}
    >
      <span className="booking-type-panel__icon" aria-hidden="true">
        {isInstant ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        )}
      </span>
      <div className="booking-type-panel__body">
        <h3 className="booking-type-panel__title">{type}</h3>
        <p className="booking-type-panel__copy">
          {isInstant
            ? 'Você paga e a vaga já fica garantida, sem espera, sem incerteza. A confirmação chega no WhatsApp em segundos.'
            : 'Sua solicitação vai para o operador, que confirma a disponibilidade em até 24h. Você só recebe o link de pagamento após a confirmação.'}
        </p>
      </div>
    </section>
  );
}
